import React, { useEffect, useState } from 'react';
import { Outlet, Link,  useParams, useNavigate  } from "react-router-dom";
import ContentHeader from '../../parts/ContentHeader';
import MainContainer from '../../parts/MainContainer';
import InputText from '../../elements/InputText'
import InputTextArea from '../../elements/InputTextArea'
import DropDownSelection from '../../elements/DropDownSelection';
import Radio from '../../elements/InputRadio';
import InputFile from '../../elements/InputFile';
import Checkbox from '../../elements/InputCheckbox';
import Loader from '../../parts/Loader';
import InputNumber from '../../elements/InputNumber';
import RenderErrors from '../../elements/RenderErrors';
import store from '../../../helpers/store';
import helpers from '../../../helpers/helpers';
import { httpRequest, httpAuthHeaders, httpFormRequest } from '../../../helpers/httpService';
import Swal from 'sweetalert2';
 
function UserManagementForm ({readonly = false}){
    let { id } = useParams();
    const [form_data, setForm] = useState(store.user_data);
    const [form_title, SetTitle] = useState('');
    const [employee_list, SetEmployees] = useState([]);
    const [role_list, SetRoles] = useState([]);
    const [loading, setLoading] = useState(0);
    const [errors, setErrors] = useState([]);
    let navigate = useNavigate();

    useEffect(() => {
        getEmployees();
        getRoles();

        //Mounted
        if(id){
            getData(id)
            SetTitle('Update User')
        }
        else{
            SetTitle('Create New User')
        }
    }, []);

    function getEmployees(){
        const url = helpers.getUrl('admin/employees')
        setLoading(1)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                let data = {}
                
                if (Object.keys(res.data).length > 0) {
                    data = Object.entries(res.data).map(([key, data]) => {

                        data.full_name = `${data.first_name} ${data.last_name}` 

                        return data
                    })

                    data = [
                        {'id': '', 'full_name': '[Unselect]'},
                        ...data
                    ]

                    SetEmployees(data)
                }

                setLoading(0)
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    //title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }

    function getRoles(){
        const url = helpers.getUrl('admin/roles')
        setLoading(1)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                SetRoles(res.data)

                setLoading(0)
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    //title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }

    function getData(id){
        const url = helpers.getUrl('admin/users/' + id)
        setLoading(1)

        httpRequest(url, "GET", {}, true)
            .then((res) => {

                setForm({
                    'employee_id': res.employee_id, 
                    'name': res.name, 
                    'email': res.email, 
                    'password': '',
                    'confirm_password': '',
                    'status': res.status,
                    'role_id': res.role_id
                 })

                setLoading(0)
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    //title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }

    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;

                if(name == 'warranty_status') value = 'active'
            } else {
                value = 0;

                if(name == 'warranty_status') value = 'expired'
            }
        }
        else if (e.target.type === "file") {
          value = e.target.files[0]
        }

        let new_state = { [name]: value }

        if(name==='employee_id'){
            const employee = employee_list.find(item => item.id == value);
            new_state.name = employee.full_name
        }

        setForm({ ...form_data, ...new_state });
    }

    function getFormData(status = 'draft'){
        let form = new FormData();

        for(var key in form_data) {
            form.append(key, form_data[key]);
        }

        return form
    }

    function submit(e){
        const formData = getFormData()

        let url = helpers.getUrl('admin/users')

        if(id){
            url = helpers.getUrl('admin/users/'+id)
        }

        setLoading(1)

        httpRequest(url, "POST", {
            postdata: form_data,
        }, true)
            .then((res) => {
                setLoading(0)

                let return_url = '/manage/user-account'
                let new_id = ''
                if(res.hasOwnProperty("data")){
                    new_id = res.data.id;
                }
                if(new_id){
                    return_url += '/' + new_id + '/edit'
                }
                else if(id){
                    return_url += '/' + id + '/edit'
                }

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        setForm({ ...form_data, 'password': '', 'confirm_password': '', });
                        return navigate(return_url);
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                
                if(err.data){
                    setErrors( err.data );
                }else{
                    setErrors([])
                }

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }
    
    return (
        <MainContainer page_title={form_title} menu="manage-users">
            <div className="container-fluid">
                <div className="row d-flex justify-content-center" style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>

                    <div className="col-sm-10 col-md-8">
                        <form className="card">
                            <div className="card-body">
                                    <div className="row">
                                        <div className="col-8 mb-3">
                                            <p className='mb-0'>User Information</p>
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <DropDownSelection
                                                tagClass="form-control"
                                                name='role_id' 
                                                placeholder='Select User Role'
                                                label={<>Role <span className="text-danger">*</span></>}
                                                value={form_data.role_id}  
                                                onChange={inputChange}
                                                optionList={role_list}
                                                optionProps ={{value:'id', label:'name'}}
                                            />
                                            <RenderErrors 
                                                errors={errors} 
                                                name="role_id" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <DropDownSelection
                                                tagClass="form-control"
                                                name='employee_id' 
                                                placeholder='Select Employee'
                                                label="Employee"
                                                value={form_data.employee_id}  
                                                onChange={inputChange}
                                                optionList={employee_list}
                                                optionProps ={{value:'id', label:'full_name'}}
                                            />
                                            <RenderErrors 
                                                errors={errors} 
                                                name="employee_id" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <InputText
                                                id="name" 
                                                name="name" 
                                                value={form_data.name}
                                                tagClass="form-control mb-0"
                                                onChange={inputChange}
                                                placeholder="Name"
                                                type="text"
                                                label="Display Name"
                                                //readOnly={form_data.employee_id}
                                            />
                                            <RenderErrors 
                                                errors={errors} 
                                                name="name" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <InputText
                                                id="email" 
                                                name="email" 
                                                value={form_data.email}
                                                tagClass="form-control mb-0"
                                                onChange={inputChange}
                                                placeholder="Email"
                                                type="email"
                                                label={<>Email <span className="text-danger">*</span></>}
                                                readOnly={readonly}
                                            />
                                            <RenderErrors 
                                                errors={errors} 
                                                name="email" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>
                                        <div className="col-12">{id ? <small>Note: Leave Password &amp; Confirm Password blank if not need to update.</small>: ""}</div>
                                        <div className="col-md-6 form-group">
                                            <InputText
                                                id="password" 
                                                name="password" 
                                                value={form_data.password}
                                                tagClass="form-control mb-0"
                                                onChange={inputChange}
                                                placeholder="Password"
                                                type="password"
                                                label={<>Password <span className="text-danger">*</span></>}
                                                readOnly={readonly}
                                            />
                                            <RenderErrors 
                                                errors={errors} 
                                                name="password" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <InputText
                                                id="confirm_password" 
                                                name="confirm_password" 
                                                value={form_data.confirm_password}
                                                tagClass="form-control mb-0"
                                                onChange={inputChange}
                                                placeholder="Confirm Password"
                                                type="password"
                                                label={<>Comfirm Passowrd <span className="text-danger">*</span></>}
                                                readOnly={readonly}
                                            />
                                            <RenderErrors 
                                                errors={errors} 
                                                name="confirm_password" 
                                                className="text-danger"
                                                style={{fontSize: '.9rem'}}
                                            />
                                        </div>
                                        <div className="col-12"></div>
                                        <div className="col-sm-6 col-md-4 form-group">
                                            <div className="form-check" style={{padding: '0.5rem', paddingLeft: '1.5rem'}}>
                                                <Checkbox
                                                    id="status"
                                                    name="status"
                                                    value={form_data.status}
                                                    label='Active'
                                                    labelClass="form-check-label"
                                                    tagClass="form-check-input"
                                                    onChange={inputChange}
                                                    checked = {form_data.status}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                
                            </div>
                            <div className="card-footer text-right">   
                                    <Link className='mr-3' to="/manage/user-account"><i className="fas fa-arrow-left mr-3" />Back</Link>
                                    <button type='button' className='btn btn-success btn-sm' onClick={submit}><i className="fas fa-save mr-2" />{id ? 'Update' : 'Save'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainContainer>
    )
}
 
export default UserManagementForm;